import React from "react"
import { imagePlaceholder } from "../../normalizer"

const PostSaleProductPlaceholder = ({ colors, tight }) => {
  
  return (
        <div className="product-card">
      <div className="product-card-image-container">
        <img src={imagePlaceholder} alt={"placeholder"} />
      </div>
      <div className={`product-card-info-container ${tight ? "tight" : ""}`}>
        <div className="product-card-info-title">Produto previsto</div>
        <div className="product-card-info-points">
          <span className="product-card-info-points-container-points">
          </span>
          <span className="product-card-info-points-container-currency">
            
          </span>
        </div>
        <div className="product-card-info-filler"></div>
      </div>
    </div>

  )
}

export default PostSaleProductPlaceholder
